import { redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';

const BASE_PATH = '/reports';

export const ReportsRoutes = [
    {
        path: BASE_PATH,
        name: 'ReportGenerator',
        component: () => import('@/app/modules/reports/ReportGenerator.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.reports),
    },
];
